import { TextCodes } from '@api/types/translation/TextCodes';
import { Text } from '@components/common/Text/Text/Text';
import { Paper } from '@mui/material';
import { t } from '@translations';
import { useContext } from 'react';
import { ProductDetailsContext } from './ProductDetailsContext';

export const ProductPackageInfo = () => {
  const { product = {} } = useContext(ProductDetailsContext);
  const {
    productPacakgeYesNo = {},
    itemPackageBatteryCharger = {},
    itemPackageNumberBatteries = {},
    itemPackageNumberChargers = {},
  } = product;
  const packageIncludedValue = productPacakgeYesNo?.value;
  const packageIncluded: boolean = packageIncludedValue?.toLowerCase() === 'true';

  if (!packageIncluded) return null;

  const batteries = itemPackageNumberBatteries?.value;
  const chargers = itemPackageNumberChargers?.value;

  const getTextCode = () => {
    let battery = itemPackageBatteryCharger?.value?.[0];
    let charger = itemPackageBatteryCharger?.value?.[1];

    if (itemPackageBatteryCharger?.value?.length === 1) {
      const onlyItem = itemPackageBatteryCharger.value[0];
      if (itemPackageNumberBatteries?.value && !itemPackageNumberChargers?.value) {
        battery = onlyItem;
        charger = undefined;
      } else if (!itemPackageNumberBatteries?.value && itemPackageNumberChargers?.value) {
        charger = onlyItem;
        battery = undefined;
      }
    }

    if (charger && battery) {
      if (batteries && chargers && Number(batteries) > 1 && Number(chargers) > 1) {
        return t(TextCodes.Product.Details.IncludeBatteriesAndChargers, {
          batteries,
          chargers,
          battery,
          charger,
        });
      } else if (batteries && chargers && Number(batteries) > 1 && Number(chargers) === 1) {
        return t(TextCodes.Product.Details.IncludeBatteriesAndCharger, {
          batteries,
          battery,
          charger,
        });
      } else if (batteries && chargers && Number(batteries) === 1 && Number(chargers) > 1) {
        return t(TextCodes.Product.Details.IncludeBatteryAndChargers, {
          battery,
          chargers,
          charger,
        });
      } else if (batteries && chargers && Number(batteries) === 1 && Number(chargers) === 1) {
        return t(TextCodes.Product.Details.IncludeBatteryAndCharger, { battery, charger });
      } else if (batteries && !chargers) {
        return t(TextCodes.Product.Details.IncludeBatteryOnly, { battery });
      } else if (!batteries && chargers) {
        return t(TextCodes.Product.Details.IncludeChargerOnly, { charger });
      }
      return null;
    }

    if (charger && !battery) {
      if (chargers && Number(chargers) > 1) {
        return t(TextCodes.Product.Details.IncludeChargersOnly, { chargers, charger });
      }
      return t(TextCodes.Product.Details.IncludeChargerOnly, { charger });
    }

    if (!charger && battery) {
      if (batteries && Number(batteries) > 1) {
        return t(TextCodes.Product.Details.IncludeBatteriesOnly, { batteries, battery });
      }
      return t(TextCodes.Product.Details.IncludeBatteryOnly, { battery });
    }
    return null;
  };

  const translations = getTextCode();

  return translations ? (
    <Paper elevation={0} square sx={{ p: 1 }}>
      <Text>{translations}</Text>
    </Paper>
  ) : null;
};
